<div *ngIf="!ingreso">
     <!-- <video onloadedmetadata="this.muted=true" autoplay id="video_login">
       <source src="assets/img/login/Intro-portal.mp4" type="video/mp4">
     </video> -->
     <img src="assets/img/login/Intro_Portal_Imagen.jpg" alt="ImgLogin" type="img" id="imagen_login">
</div>
<div *ngIf="!ingreso">
     <app-login></app-login>
</div>
<div *ngIf="ingreso">
     <app-home></app-home>
</div>